import { Injectable } from '@angular/core';
import { ISizeRuns, ProductService } from '@epicuro-next/data/product';
import { selectActiveAccountBrandOrg } from '@epicuro-next/state/accounts-state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { OrderType } from 'graphql-api/gql-api-interfaces';
import { forkJoin, of } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';

import {
  loadProductSuccess,
  loadSizeRuns,
  loadSizeRunsSuccess,
} from '../actions/config-strip.actions';

@Injectable()
export class ProductSizeRunsEffects {
  public loadSizeRuns$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSizeRuns),
      concatLatestFrom(() => [
        this.store.pipe(select(selectActiveAccountBrandOrg)),
      ]),
      filter(([, id]) => !!id),
      switchMap(([{ product }, brandOrganisationId]) => {
        const payload = {
          brandOrganisationId: [brandOrganisationId as string],
          ...Object.keys(product.masterAttributes).reduce(
            (acc: Record<string, unknown>, item: string) => {
              acc[item] = [product.masterAttributes[item]];

              return acc;
            },
            {},
          ),
        };

        return forkJoin({
          now: this.productService
            .getSizeRuns({
              ...payload,
              ordertype: [OrderType.Now.toLowerCase()],
            })
            .pipe(catchError(() => of(undefined))),
          future: this.productService
            .getSizeRuns({
              ...payload,
              ordertype: [OrderType.Future.toLowerCase()],
            })
            .pipe(catchError(() => of(undefined))),
        }).pipe(
          switchMap((response: ISizeRuns) => {
            if (!response.now && !response.future) {
              return [loadProductSuccess({ product })];
            }

            return [
              loadSizeRunsSuccess({ sizeRuns: response }),
              loadProductSuccess({
                product,
              }),
            ];
          }),
          catchError(() =>
            of(
              loadProductSuccess({
                product,
              }),
            ),
          ),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private productService: ProductService,
    private store: Store,
  ) {}
}
